// TODO - Documentar
import { useEffect, useState } from 'react'
import { RefApplicationParameterHook, EditApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { RefSurrogateUser, RefUser } from '../hooks/AuthenticationHook'
import CustomNavSelect from './CustomNavSelect'
import * as con from "../../GlobalConstants"
import { sortArrayByAttribute } from '../../GlobalFunctions'
import { useDispatch } from 'react-redux'
import { setSurrogateUserById } from '../../store/slices/applicationParametersSlice'
import { RefModelParameterHook } from '../hooks/ModelParameterHooks'

function CustomUsersSelect() {

    const dispatch = useDispatch();
    const setPendingSurrogateUserId = EditApplicationParameterHook(con.PENDING_SURROGATE_USER_ID)
    const setShowUnsavedModal  = EditApplicationParameterHook(con.SHOW_UNSAVED_MODAL)

    // Current user
    const user = RefUser()   // Surrogate User List
    const surrogateUserList = RefApplicationParameterHook(con.SURROGATE_USER_DICT)   // Surrogate user
    const surrogateUser = RefSurrogateUser()
    const modelParametersSaved = RefModelParameterHook(con.MODEL_PARAMETERS_SAVED)
    const [selectedValue, setSelectedValue] = useState(() => user[con.ID])

    useEffect(() => {           
        setSelectedValue(surrogateUser === null ? user[con.ID] : surrogateUser[con.ID])
    }, [surrogateUser, user])

    // Local Data
    const [completeSurrogateList, setCompleteSurrogateList] = useState(() => [user].concat(Object.values(surrogateUserList)))


    useEffect(() => {
      setCompleteSurrogateList([user].concat(Object.values(surrogateUserList)))
    }, [surrogateUserList, user])

     const handleUserChange = (e) => {
      const newUserId = e.target.value;
    
      if (modelParametersSaved === con.PENDING) {
        setPendingSurrogateUserId(newUserId);
        setShowUnsavedModal(true);
      } else {
        dispatch(setSurrogateUserById(newUserId));
      }
    };
   

  return (
    
    <CustomNavSelect values={sortArrayByAttribute(completeSurrogateList,con.USERNAME).map(ob => ob[con.ID])} 
                    labels = {sortArrayByAttribute(completeSurrogateList,con.USERNAME).map(ob => ob[con.USERNAME])} 
                    onChange={handleUserChange}
                    selectedValue={selectedValue}/> 
                                                              
  )
}

export default CustomUsersSelect